<app-region-banner></app-region-banner>
<xpo-shell style="height: 0 !important;">
  <!--override height to avoid weird scroll when region banner is present-->
  <xpo-header-app-name>Edge</xpo-header-app-name>
  <xpo-header-sub-app-name>Customer Rules</xpo-header-sub-app-name>
  <div class="app-container" fxFlex="" fxLayout="column">
    <div class="app-container-content" [ngClass]="{ 'app-container-content-non-prod': !isProduction }">
      <div class="app-container-inner-content">
        <router-outlet></router-outlet>
        <app-notification></app-notification>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</xpo-shell>
